module.exports = __webpack_public_path__ + "static/media/facebookreward.876b55ac.svg";